import { render, staticRenderFns } from "./home-tour-card.vue?vue&type=template&id=3406ff1b&scoped=true&"
import script from "./home-tour-card.vue?vue&type=script&lang=js&"
export * from "./home-tour-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3406ff1b",
  null
  
)

export default component.exports